// Pure helpers for the PDF "Sida x av y" control (library finding L4).

// Clamp a page number into 1..pageCount (a non-positive count yields 1).
export const clampPage = (page: number, pageCount: number): number =>
    Math.min(Math.max(page, 1), Math.max(pageCount, 1));

// Parse what the author typed. A whole number (any size) clamps into range;
// anything else (empty, text, decimals) is `null` — the caller reverts.
export const parsePageInput = (
    text: string,
    pageCount: number,
): number | null => {
    const trimmed = text.trim();
    return /^\d+$/.test(trimmed)
        ? clampPage(Number.parseInt(trimmed, 10), pageCount)
        : null;
};

// The current page from per-page visible ratios: the most visible page; ties
// go to the earlier page. Nothing visible ⇒ `null` (keep the previous page).
export const pickCurrentPage = (
    ratios: ReadonlyMap<number, number>,
): number | null =>
    [...ratios.entries()]
        .filter(([, ratio]) => ratio > 0)
        .reduce<readonly [number, number] | null>(
            (best, entry) =>
                best === null ||
                entry[1] > best[1] ||
                (entry[1] === best[1] && entry[0] < best[0])
                    ? entry
                    : best,
            null,
        )?.[0] ?? null;
